import { render, staticRenderFns } from "./LegajoDetalleLectura.vue?vue&type=template&id=7b4286ab&scoped=true"
import script from "./LegajoDetalleLectura.vue?vue&type=script&lang=js"
export * from "./LegajoDetalleLectura.vue?vue&type=script&lang=js"
import style0 from "../control-prestaciones/cp-page.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./LegajoDetalleLectura.vue?vue&type=style&index=1&id=7b4286ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4286ab",
  null
  
)

export default component.exports